module.exports = __webpack_public_path__ + "img/11.4186eed1.jpg";